import React, { Component } from "react";

export default class TheAttachment extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          border: "1px solid #d9d9d9",
          padding: "10px 12px 10px 12px",
          height: !!this.props.value ? null : 40,
        }}
      >
        {/* eslint-disable */}
        <a
          href={`${this.props.main_url}employee/getCRDocumentData/${this.props.user_id}/${this.props.doc}`}
          download
          target="_blank"
          style={{
            color: "#7D7D7D",
            fontSize: 14,
          }}
        >
          {this.props.doc.split("&@")[1]}
        </a>
        <a onClick={(event) => this.props.removeOldDocument(event)}>
          {/* eslint-enable */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              fontSize: "14px",
              background: "#fe7676",
              boxShadow: "-1px 1px 6px rgba(254,118,118,.8)",
              textShadow: "none",
              width: "20px",
              height: "20px",
              borderRadius: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "3px",
                fontWeight: "bold",
              }}
            >
              x
            </div>
          </div>
        </a>
      </div>
    );
  }
}
